import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "styled-components";
import WBCAdminAccess from "../protected/WBCAdminAccess";
import EligibilityButtonFormatter from "./EligibilityButtonFormatter";
import { StatusText, getEligibilityStatusStyles } from "../elements/CommonStyledComponents";

const EligibilityFormatter = ({ value, row, onOpenEligibilityModal }) => {
  const theme = useContext(ThemeContext);
  const { bgColor, color } = getEligibilityStatusStyles(value, theme);

  return (
    <div className="d-flex justify-content-between align-items-center">
      {value && (
        <StatusText bgColor={bgColor} color={color}>
          {value === "Submitted" ? "Pending" : value === "Yes" ? "Approved" : value === "No" ? "Denied" : ""}
        </StatusText>
      )}
      {!value && <div />}
      <WBCAdminAccess>
        <div>
          <EligibilityButtonFormatter row={row} onOpenEligibilityModal={onOpenEligibilityModal} />
        </div>
      </WBCAdminAccess>
    </div>
  );
};

EligibilityFormatter.propTypes = {
  value: PropTypes.string,
  row: PropTypes.object,
  onOpenEligibilityModal: PropTypes.func.isRequired
};

export default EligibilityFormatter;
